import { ActivationMethodEnum, ActivationMethodType } from 'models';

export const ActivationMethodTypes: ActivationMethodType[] = [
  {
    method: ActivationMethodEnum.Mnp,
    title: 'ENTITY.ACTIVATION-METHOD.OLD-NUMBER',
    images: [
      {
        alt: 'ENTITY.ACTIVATION-METHOD.OLD-NUMBER',
        src: '/assets/images/icon-activation-mnp.svg'
      }
    ]
  },
  {
    method: ActivationMethodEnum.New,
    title: 'ENTITY.ACTIVATION-METHOD.NEW-NUMBER',
    images: [
    {
        alt: 'ENTITY.ACTIVATION-METHOD.NEW-NUMBER',
        src: '/assets/images/icon-activation-new.svg'
        }
    ]
  }
];
